<template>
    <div>
        <div class="btn-group" role="group">
            <button type="button" class="btn btn-secondary" @click="openFile" v-if="canOpen">
                <i class="far fa-folder-open"/>
            </button>
            <button type="button" class="btn btn-secondary" @click="record" v-if="canRecord">
                <i class="fas fa-microphone"></i>
            </button>
            <button type="button" class="btn btn-secondary" @click="stop" v-if="canStop">
                <i class="fas fa-stop"></i>
            </button>
        </div>
        <input ref="input" class="d-none" type="file" @change="fileSelect"/>
    </div>

</template>

<script>
  import Recorder from '../../libs/audio-recorder';

  export default {
    data() {
      return {
        recorder: null,
        isRecording: false,
      }
    },

    computed: {
      /**
       * @return {boolean}
       */
      canOpen() {
        return this.isRecording === false;
      },

      /**
       * @return {boolean}
       */
      canRecord() {
        return Boolean(this.recorder) && this.isRecording === false;
      },

      /**
       * @return {boolean}
       */
      canStop() {
        return this.isRecording === true;
      }
    },

    methods: {
      /**
       * @return {undefined}
       */
      openFile() {
        this.$refs.input.click();
      },

      /**
       * @param {object} event
       */
      fileSelect(event) {
        this.emit(_.get(event, 'target.files.0'));
      },

      /**
       * @param {File|null} file
       * @emits input
       */
      emit(file) {
        this.$emit('input', file);
      },

      /**
       * @return {undefined}
       */
      record() {
        this.recorder
          .start()
          .then(() => {
            this.isRecording = true;
          });
      },

      /**
       * @return {undefined}
       */
      stop() {
        this.recorder
          .stop()
          .then(file => {
            this.isRecording = false;
            this.emit(file);
          });
      },

      /**
       * @param {*} err
       * @return {string|null}
       */
      getErrorMessage(err) {
        if (!err instanceof Error) {
          return 'General recorder error';
        } else if (err.name === 'RecorderError') {
          return err.message;
        } else if (err.name === 'RecorderErrorNoDevice') {
          return null;
        }

        return _.thru(err.message || 'no details', m => `Recorder error: ${m}`);
      },
    },

    mounted() {
      Recorder()
        .then(recorder => this.recorder = recorder)
        .catch(err => {
          const message = this.getErrorMessage(err);
          message && this.$message.error(message);
        });
    },

    beforeDestroy() {
      this.recorder && this.recorder.destroy();
    }
  }
</script>
